export const UPDATE_QUIZ = 'UPDATE_QUIZ';

export const GET_QUIZ_REQUEST = 'GET_QUIZ_REQUEST';
export const GET_QUIZ_SUCCESS = 'GET_QUIZ_SUCCESS';
export const GET_QUIZ_FAIL = 'GET_QUIZ_FAIL';

export const GET_ALL_QUIZZES_REQUEST = 'GET_ALL_QUIZZES_REQUEST';
export const GET_ALL_QUIZZES_SUCCESS = 'GET_ALL_QUIZZES_SUCCESS';
export const GET_ALL_QUIZZES_FAIL = 'GET_ALL_QUIZZES_FAIL';

export const GET_QUIZZES_BY_MODULE_REQUEST = 'GET_QUIZZES_BY_MODULE_REQUEST';
export const GET_QUIZZES_BY_MODULE_SUCCESS = 'GET_QUIZZES_BY_MODULE_SUCCESS';
export const GET_QUIZZES_BY_MODULE_FAIL = 'GET_QUIZZES_BY_MODULE_FAIL';

export const GET_QUIZZES_BY_TYPE_REQUEST = 'GET_QUIZZES_BY_TYPE_REQUEST';
export const GET_QUIZZES_BY_TYPE_SUCCESS = 'GET_QUIZZES_BY_TYPE_SUCCESS';
export const GET_QUIZZES_BY_TYPE_FAIL = 'GET_QUIZZES_BY_TYPE_FAIL';

export const CREATE_QUIZ_REQUEST = 'CREATE_QUIZ_REQUEST';
export const CREATE_QUIZ_SUCCESS = 'CREATE_QUIZ_SUCCESS';
export const CREATE_QUIZ_FAIL = 'CREATE_QUIZ_FAIL';

export const UPDATE_QUIZ_REQUEST = 'UPDATE_QUIZ_REQUEST';
export const UPDATE_QUIZ_SUCCESS = 'UPDATE_QUIZ_SUCCESS';
export const UPDATE_QUIZ_FAIL = 'UPDATE_QUIZ_FAIL';

export const DELETE_QUIZ_REQUEST = 'DELETE_QUIZ_REQUEST';
export const DELETE_QUIZ_SUCCESS = 'DELETE_QUIZ_SUCCESS';
export const DELETE_QUIZ_FAIL = 'DELETE_QUIZ_FAIL';

export const SET_QUIZ_LOADING = 'SET_QUIZ_LOADING';
export const CLEAR_QUIZ_MESSAGE = 'CLEAR_QUIZ_MESSAGE';

// Questions
export const GET_QUESTIONS_BY_QUIZ_REQUEST = 'GET_QUESTIONS_BY_QUIZ_REQUEST';
export const GET_QUESTIONS_BY_QUIZ_SUCCESS = 'GET_QUESTIONS_BY_QUIZ_SUCCESS';
export const GET_QUESTIONS_BY_QUIZ_FAIL = 'GET_QUESTIONS_BY_QUIZ_FAIL';

export const CREATE_QUESTION_REQUEST = 'CREATE_QUESTION_REQUEST';
export const CREATE_QUESTION_SUCCESS = 'CREATE_QUESTION_SUCCESS';
export const CREATE_QUESTION_FAIL = 'CREATE_QUESTION_FAIL';

export const UPDATE_QUESTION_REQUEST = 'UPDATE_QUESTION_REQUEST';
export const UPDATE_QUESTION_SUCCESS = 'UPDATE_QUESTION_SUCCESS';
export const UPDATE_QUESTION_FAIL = 'UPDATE_QUESTION_FAIL';

export const DELETE_QUESTION_REQUEST = 'DELETE_QUESTION_REQUEST';
export const DELETE_QUESTION_SUCCESS = 'DELETE_QUESTION_SUCCESS';
export const DELETE_QUESTION_FAIL = 'DELETE_QUESTION_FAIL';

// ===== Passage quiz / tentative =====
export const START_QUIZ_ATTEMPT_REQUEST = 'START_QUIZ_ATTEMPT_REQUEST';
export const START_QUIZ_ATTEMPT_SUCCESS = 'START_QUIZ_ATTEMPT_SUCCESS';
export const START_QUIZ_ATTEMPT_FAIL = 'START_QUIZ_ATTEMPT_FAIL';

export const SUBMIT_QUIZ_ATTEMPT_REQUEST = 'SUBMIT_QUIZ_ATTEMPT_REQUEST';
export const SUBMIT_QUIZ_ATTEMPT_SUCCESS = 'SUBMIT_QUIZ_ATTEMPT_SUCCESS';
export const SUBMIT_QUIZ_ATTEMPT_FAIL = 'SUBMIT_QUIZ_ATTEMPT_FAIL';

export const GET_QUIZ_ATTEMPT_REQUEST = 'GET_QUIZ_ATTEMPT_REQUEST';
export const GET_QUIZ_ATTEMPT_SUCCESS = 'GET_QUIZ_ATTEMPT_SUCCESS';
export const GET_QUIZ_ATTEMPT_FAIL = 'GET_QUIZ_ATTEMPT_FAIL';

export const GET_ATTEMPTS_BY_COLLABORATEUR_REQUEST = 'GET_ATTEMPTS_BY_COLLABORATEUR_REQUEST';
export const GET_ATTEMPTS_BY_COLLABORATEUR_SUCCESS = 'GET_ATTEMPTS_BY_COLLABORATEUR_SUCCESS';
export const GET_ATTEMPTS_BY_COLLABORATEUR_FAIL = 'GET_ATTEMPTS_BY_COLLABORATEUR_FAIL';

export const CLEAR_QUIZ_PLAYER_STATE = 'CLEAR_QUIZ_PLAYER_STATE';

// ===== Quiz =====
export const updateQuiz = (quiz) => ({
    type: UPDATE_QUIZ,
    quiz
});

export const getQuizRequest = (quizId) => ({
    type: GET_QUIZ_REQUEST,
    payload: { quizId }
});

export const getQuizSuccess = (quiz) => ({
    type: GET_QUIZ_SUCCESS,
    payload: quiz
});

export const getQuizFail = (error) => ({
    type: GET_QUIZ_FAIL,
    error
});

export const getAllQuizzesRequest = () => ({
    type: GET_ALL_QUIZZES_REQUEST
});

export const getAllQuizzesSuccess = (quizzes) => ({
    type: GET_ALL_QUIZZES_SUCCESS,
    payload: quizzes
});

export const getAllQuizzesFail = (error) => ({
    type: GET_ALL_QUIZZES_FAIL,
    error
});

export const getQuizzesByModuleRequest = (moduleId) => ({
    type: GET_QUIZZES_BY_MODULE_REQUEST,
    payload: { moduleId }
});

export const getQuizzesByModuleSuccess = (quizzes) => ({
    type: GET_QUIZZES_BY_MODULE_SUCCESS,
    payload: quizzes
});

export const getQuizzesByModuleFail = (error) => ({
    type: GET_QUIZZES_BY_MODULE_FAIL,
    error
});

export const getQuizzesByTypeRequest = (typeQuiz) => ({
    type: GET_QUIZZES_BY_TYPE_REQUEST,
    payload: { typeQuiz }
});

export const getQuizzesByTypeSuccess = (quizzes) => ({
    type: GET_QUIZZES_BY_TYPE_SUCCESS,
    payload: quizzes
});

export const getQuizzesByTypeFail = (error) => ({
    type: GET_QUIZZES_BY_TYPE_FAIL,
    error
});

export const createQuizRequest = (quizData, history) => ({
    type: CREATE_QUIZ_REQUEST,
    payload: quizData,
    history
});

export const createQuizSuccess = (quiz) => ({
    type: CREATE_QUIZ_SUCCESS,
    payload: quiz
});

export const createQuizFail = (error) => ({
    type: CREATE_QUIZ_FAIL,
    error
});

export const updateQuizRequest = (quizId, quizData) => ({
    type: UPDATE_QUIZ_REQUEST,
    payload: { quizId, quizData }
});

export const updateQuizSuccess = (quiz) => ({
    type: UPDATE_QUIZ_SUCCESS,
    payload: quiz
});

export const updateQuizFail = (error) => ({
    type: UPDATE_QUIZ_FAIL,
    error
});

export const deleteQuizRequest = (quizId) => ({
    type: DELETE_QUIZ_REQUEST,
    payload: { quizId }
});

export const deleteQuizSuccess = (quizId) => ({
    type: DELETE_QUIZ_SUCCESS,
    payload: { quizId }
});

export const deleteQuizFail = (error) => ({
    type: DELETE_QUIZ_FAIL,
    error
});

export const setQuizLoading = (loading) => ({
    type: SET_QUIZ_LOADING,
    payload: loading
});

export const clearQuizMessage = () => ({
    type: CLEAR_QUIZ_MESSAGE
});

// ===== Questions =====
export const getQuestionsByQuizRequest = (quizId) => ({
    type: GET_QUESTIONS_BY_QUIZ_REQUEST,
    payload: { quizId }
});

export const getQuestionsByQuizSuccess = (questions) => ({
    type: GET_QUESTIONS_BY_QUIZ_SUCCESS,
    payload: questions
});

export const getQuestionsByQuizFail = (error) => ({
    type: GET_QUESTIONS_BY_QUIZ_FAIL,
    error
});

export const createQuestionRequest = (questionData) => ({
    type: CREATE_QUESTION_REQUEST,
    payload: questionData
});

export const createQuestionSuccess = (question) => ({
    type: CREATE_QUESTION_SUCCESS,
    payload: question
});

export const createQuestionFail = (error) => ({
    type: CREATE_QUESTION_FAIL,
    error
});

export const updateQuestionRequest = (questionId, questionData) => ({
    type: UPDATE_QUESTION_REQUEST,
    payload: { questionId, questionData }
});

export const updateQuestionSuccess = (question) => ({
    type: UPDATE_QUESTION_SUCCESS,
    payload: question
});

export const updateQuestionFail = (error) => ({
    type: UPDATE_QUESTION_FAIL,
    error
});

export const deleteQuestionRequest = (questionId) => ({
    type: DELETE_QUESTION_REQUEST,
    payload: { questionId }
});

export const deleteQuestionSuccess = (questionId) => ({
    type: DELETE_QUESTION_SUCCESS,
    payload: { questionId }
});

export const deleteQuestionFail = (error) => ({
    type: DELETE_QUESTION_FAIL,
    error
});


// ===== Passage quiz / tentative =====

export const startQuizAttemptRequest = (payload) => ({
    type: START_QUIZ_ATTEMPT_REQUEST,
    payload
});

export const startQuizAttemptSuccess = (payload) => ({
    type: START_QUIZ_ATTEMPT_SUCCESS,
    payload
});

export const startQuizAttemptFail = (error) => ({
    type: START_QUIZ_ATTEMPT_FAIL,
    error
});

export const submitQuizAttemptRequest = (payload) => ({
    type: SUBMIT_QUIZ_ATTEMPT_REQUEST,
    payload
});

export const submitQuizAttemptSuccess = (payload) => ({
    type: SUBMIT_QUIZ_ATTEMPT_SUCCESS,
    payload
});

export const submitQuizAttemptFail = (error) => ({
    type: SUBMIT_QUIZ_ATTEMPT_FAIL,
    error
});

export const getQuizAttemptRequest = (tentativeId) => ({
    type: GET_QUIZ_ATTEMPT_REQUEST,
    payload: { tentativeId }
});

export const getQuizAttemptSuccess = (payload) => ({
    type: GET_QUIZ_ATTEMPT_SUCCESS,
    payload
});

export const getQuizAttemptFail = (error) => ({
    type: GET_QUIZ_ATTEMPT_FAIL,
    error
});

export const getAttemptsByCollaborateurRequest = (collaborateurId) => ({
    type: GET_ATTEMPTS_BY_COLLABORATEUR_REQUEST,
    payload: { collaborateurId }
});

export const getAttemptsByCollaborateurSuccess = (payload) => ({
    type: GET_ATTEMPTS_BY_COLLABORATEUR_SUCCESS,
    payload
});

export const getAttemptsByCollaborateurFail = (error) => ({
    type: GET_ATTEMPTS_BY_COLLABORATEUR_FAIL,
    error
});

export const clearQuizPlayerState = () => ({
    type: CLEAR_QUIZ_PLAYER_STATE
});